import React from 'react';
import TextField from './text-field';

export default class TextArea extends TextField {

    constructor(props) {
        super(props);
        this._inputtype = (props) => <textarea {...props}> {props.children} </textarea>;
    }
}